import { Component, OnInit, Input } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalConfirmComponent } from '../modal-confirm/modal-confirm.component';
import { CaptchaService } from 'src/app/components/layout/service/captcha.service';
import { ModErrorComponent } from '../../../layout/modals/mod-error/mod-error.component';

@Component({
  selector: 'app-leader-group-access-form',
  templateUrl: './leader-group-access-form.component.html',
  styleUrls: ['./leader-group-access-form.component.css']
})
export class LeaderGroupAccessFormComponent implements OnInit {
  @Input()publicJwt: string;
  
  accessPage: boolean = false;
  Request: any;
  leaderForm: UntypedFormGroup;

  countries: any;
  key:string;
  peopleIn: any= [];
  peopleOut: any= [];

  // file
  filesize = false;
  fileformat = false;
  fileName = 'false';
  fileError = false;
  excelvalid =true;


  //CONTROLS 
  controlMaxPeople= false;
  controlNotPeopleValid=false;
  controlInvalidFormat= false;


  urlExcel = "https://drive.google.com/uc?id=1rDqFoyS7mMgJqASTx9KVd_5IZnAhAdC9&export=download";

  submited = false;

  constructor(private dataApi: CaptchaService, private _snackBar: MatSnackBar,private route: ActivatedRoute,
              private spinner: NgxSpinnerService, private formBuilder: UntypedFormBuilder, private router: Router,
              public dialog: MatDialog ) {
    this.key = environment.googleCaptchaProps.key;
    this.publicJwt = this.route.snapshot.queryParamMap.get('form');
  }

  ngOnInit() {
    this.leaderForm = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      country:['', Validators.required],
      documentType:['', Validators.required],
      documentNumber:['', Validators.required],
      gender: ['', Validators.required],
      phone:['', [Validators.min(0) ,Validators.required]],
      company:['', Validators.required],
      safetyOrganization:['', Validators.required],
      emergencyFullName:['', Validators.required],
      emergencyPhone:['', Validators.required],
      verificationCode: ['', Validators.required],
      confirm:[false, Validators.required],
      email: ['', Validators.required],
    });
  }



  resolved(captchaResponse: string) {
    if(this.publicJwt===null || this.publicJwt===undefined){
      this.router.navigate(['/404']);
    }
    this.spinner.show("loading");
    this.dataApi.verifyCaptcha(captchaResponse, this.publicJwt).subscribe((data: any)=> {
      if(data.validToken && data.validToken==='false'){
        this.router.navigate(['/404']);
      }
      if(data.validate){
        this.accessPage=Boolean(data.validate)
      }
      if(data.request){
          this.Request= data.request;
          let from = this.Request.from.split(" ")[0];
          let to = this.Request.to.split(" ")[0];
          this.Request.from=from;
          this.Request.to=to;
      }
      if(data.personalData){
         this.leaderForm.controls.firstName.setValue(data.personalData.firstName);
         this.leaderForm.controls.email.setValue(data.personalData.email);
         this.leaderForm.controls.lastName.setValue(data.personalData.lastName);
        /* this.leaderForm.controls.documentNumber.setValue(data.personalData.documentNumber);
         this.leaderForm.controls.documentType.setValue(data.personalData.documentType);
         this.leaderForm.controls.country.setValue(data.personalData.nationality);*/
         
         if(data.personalData.nationalId){
          this.leaderForm.controls.documentNumber.setValue(data.personalData.nationalId);
          this.leaderForm.controls.documentType.setValue("nationalid");
         }else{
          this.leaderForm.controls.documentNumber.setValue(data.personalData.passportNumber);
          this.leaderForm.controls.documentType.setValue("passportnumber");
         }
         this.leaderForm.controls.country.setValue(data.personalData.nationality);
      }
      
      if(data.countries){
        this.countries= data.countriesList;
      }
     this.spinner.hide("loading");

    }, () =>{
      this.spinner.hide("loading");
      this.dialog.open(ModErrorComponent, {
        width: 'auto',
        panelClass: 'myapp-no-padding-dialog',

      });
    });
}
  deletePerson(i) {
    this.peopleIn.splice(i, 1);
  }
  deletePersonNotValid(i) {
    this.peopleOut.splice(i, 1);
  }

  downloadExcel(){
    window.window.open(this.urlExcel);
  }

  detectFiles(event) {  //Excel --
    this.controlNotPeopleValid =false;
    this.filesize = false;
    this.fileformat = false;
    this.controlInvalidFormat=false;
    const FileEx = event.target.files[0];
    const names = FileEx.name.split('.')
    const formData = new FormData();
 
    formData.append('file', FileEx);
    let numPeople= Number(this.Request.numberPeople)-1;
    formData.append('quantityVisitors', String(numPeople));
    this.controlMaxPeople = false;
    this.peopleIn = [];
    this.peopleOut = [];
    this.spinner.show("loading");
    if (!(FileEx.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' &&
    names[names.length - 1].toLocaleLowerCase() === 'xlsx')
    ) {
      this.spinner.hide("loading");
      this.fileName = 'false';
      this.fileformat = true;
      event.srcElement.value = null;
      return;
    } else {
      this.fileName = FileEx.name;
      this.fileformat = false;
    }
    if(FileEx.size >= 15000000){
      this.filesize = true;
      event.srcElement.value = null;
      this.spinner.hide("loading");
      return;
    }
    this.fileName = FileEx.name;
    this.dataApi.excelPeople(formData, this.publicJwt).subscribe((data: any) => {
  
      if(data.invalidFormat ===  undefined || data.invalidFormat === true){
        this.peopleIn = [];
        this.peopleOut = [];
        this.fileName = 'false';
        event.srcElement.value = null;
        this.controlInvalidFormat = true;
        this.spinner.hide("loading");
        return;
      }
      if(data.hasExceedLimit ===undefined || data.hasExceedLimit===true ){
        this.peopleIn = [];
        this.peopleOut = [];
        this.fileName = 'false';
        event.srcElement.value = null;
        this.controlMaxPeople = true;
        this.spinner.hide("loading");
        return;
      }else{
        this.peopleIn = data.peopleIn;
        this.peopleOut = data.peopleOut;
      }
      this.excelvalid=true;
      event.srcElement.value = null;
      this.spinner.hide("loading");
    },
                                                             () => {
                                                               this.excelvalid=false;
                                                               this.spinner.hide("loading");
                                                               this.dialog.open(ModErrorComponent, {
                                                                width: 'auto',
                                                                panelClass: 'myapp-no-padding-dialog',
                                                        
                                                              });
                                                               event.srcElement.value = null;
                                                             });

  }

  isrequired(atrr){
    return this.leaderForm.controls[atrr].hasError('required');
  }
  goTo(id: string) {
    const el = document.getElementById(id);
    el.scrollIntoView();
  }

  
openDialog() {
  this.dialog.open(ModalConfirmComponent, {panelClass: 'myapp-no-padding-dialog'}).afterClosed().subscribe((accept: boolean) => {
    if (accept) {
      this.leaderForm.controls['confirm'].setValue(true);
    }
  });
}


  onSubmit(){
    this.controlNotPeopleValid =false;

    this.spinner.show("loading");

    this.submited=true;
    if(this.isrequired('firstName') || this.isrequired('lastName') || this.isrequired('country') || 
    this.isrequired('documentType') || this.isrequired('documentNumber') || this.isrequired('phone')
    ) {
      this.goTo('LeaderInformation');
      this.spinner.hide("loading");
      return;
    }

    if(this.isrequired('gender')){ // this.isrequired('company')  || this.isrequired('safetyOrganization') 
      this.goTo('PersonalCompany');
      this.spinner.hide("loading");
      return;
    }
    if(this.isrequired('emergencyFullName') || this.isrequired('emergencyPhone')){
      this.goTo('EmergencyInfo');
      this.spinner.hide("loading");
      return;
    }

    
    if(this.leaderForm.controls['confirm'].hasError('required')){
      this.spinner.hide("loading");
      return;
    }
    if(!(this.peopleIn.length >0 && this.peopleIn.length < (Number(this.Request.numberPeople)))){
      this.spinner.hide("loading");
      this.controlNotPeopleValid =true;
      return;
    }
    let request = {
      firstName: this.leaderForm.value.firstName,
      lastName: this.leaderForm.value.lastName,
      nationality: this.leaderForm.value.country,
      email: this.leaderForm.value.email,
      company : this.leaderForm.value.company,
      phoneNumber: this.leaderForm.value.phone,
      gender: this.leaderForm.value.gender,
      safetyOrganization: this.leaderForm.value.safetyOrganization,
      emergencyContact: {
        fullName: this.leaderForm.value.emergencyFullName,
        phone: this.leaderForm.value.emergencyPhone,
      },
      peoples: [],
      verificationCode: this.leaderForm.value.verificationCode
    }

    if(this.leaderForm.value.documentType==='nationalid'){
      Object.assign(request, {  nationalId: this.leaderForm.value.documentNumber,
        passportNumber:''})
    }else {
      Object.assign(request, {  nationalId:'',
        passportNumber: this.leaderForm.value.documentNumber})
    }


    for(let person of this.peopleIn){
      const inPerson = {
        firstName: person.firstName,
        lastName: person.lastName,
        nationality: person.nationality,
        email: person.email,
        company: person.company,
        phoneNumber: person.phoneNumber,
        gender: person.gender,
        safetyOrganization: person.medicalOrganization,
        emergencyContact: {
          fullName: person.emergencyContactName,
          phone: person.emergencyContactPhone,
        },
        nationalId: person.nationalId,
        passportNumber: person.passportNumber,
      }
      request.peoples.push(inPerson)


    }

    this.dataApi.postFormPublic(request, this.publicJwt).subscribe( (response)=>{
      
      this.spinner.hide("loading");
      if(response.sucess===true){
        this.router.navigate(['/form-confirmation/success']);
      } else{
        this.router.navigate(['/form-confirmation/fail']);
      }
    }, ()=>{
      this.spinner.hide("loading");
      this.dialog.open(ModErrorComponent, {
        width: 'auto',
        panelClass: 'myapp-no-padding-dialog',

      });
    })

  }

}
